<template>

    <!-- INICIO MODAL -->

    <Modal :isOpen="isOpen" @close="toggleModal" @keyup.esc="toggleModal" >
        <div class="modal__content">
            <h1>{{ resource.name }}</h1>
            <div v-html="resource.data.Data" ></div>
            <p>{{ resource.description }}</p>
        </div>
    </Modal>

    <!-- FIN MODAL -->

    <div v-if="loader" class="resourceCard" @click="toggleModal" >
        <div class="resource__image" :style="{'background-image' : `url(${resource.data.Preview})`}" ></div>
        <div class="resource__data">
            <div>
                <h5>{{resource.name}}</h5>
                <!-- <span>lorem ipsum dolor sit amet</span> -->
            </div>
            <div class="resource__data--icon">
            </div>
        </div>
        <div class="resource__description">
            <p>{{ resource.description }}</p>
        </div>
    </div>

    <!-- SKELETOR -->
    <div v-else class="resourceCard">
        <div class="resource__image"><Skeletor width="100%" height="50%" /></div>
        <h5><Skeletor /></h5>
        <span><Skeletor /></span>
        <div class="resource__description"><Skeletor /></div>
    </div>
    <!-- END SKELETOR -->

</template>

<script>
import Modal from './Modal.vue'
import { Skeletor } from 'vue-skeletor'
import { ref} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
export default {
    components: {
        Modal,
        Skeletor
    },
    props: ['resource', 'loader'],
    setup(props){
        const route = useRoute()
        const store = useStore()
        const router = useRouter()
        const isOpen = ref(false)
        const toggleModal = () => {
            isOpen.value = !isOpen.value

            isOpen.value && getResourceById()

            if(route.path.toLowerCase().includes('/resources')){
                isOpen.value 
                ? router.replace(`/resources/${props.resource.id}`)
                : router.replace('/resources')
            }
        }

        const getResourceById = () => store.dispatch('resource_byId',props.resource.id)

        return {
            isOpen,
            toggleModal,
            getResourceById
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/styles/main.scss";

.modal__content{
    display: flex;
    flex-direction: column;
    width: 691px;
    iframe{
        width: 100%;
        //height: 400px;
    }
    h1{
        font-weight: 600;
        font-size: 22px;
        color: #404248;
        margin: 24px;
        @media screen and (max-width: 860px) {
            margin: 0;
            margin-bottom: 24px;
            font-size: 16px;
            align-self: flex-start;
        }
    }
    p{
        font-size: 12px;
        font-weight: 400;
        color: $black;
        margin: 24px auto;
        width: 70%;
        @media screen and (max-width: 860px) {
            margin: 12px 0;
            width: 100%;
        }
    }
}


.resourceCard{
    display: flex;
    flex-direction: column;
    flex: 1 1 270px;
    max-width: 320px;
    min-width: 270px;
    height: 260px;
    border-radius: 10px;
    padding: 8px;
    border: 1px solid rgba($color: #000000, $alpha: 0);
    overflow: hidden;
    cursor: pointer;
    .resource__image{
        min-height: 50%;
        border-radius: 10px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
    }
    .resource__data{
        margin: 16px 0;
        display: flex;
        justify-content: space-between;
        align-content: center;
        h5{
            font-weight: 700;
            font-size: 18px;
            color: $black;
        }
        span{
            font-weight: 600;
            font-size:12px;
            color: $black;            
        }
        &--icon{
            display: flex;
            align-items: center;
            i{
                color: $black;
            }
        }
    }
    .resource__description{
        p{
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            -moz-box-orient: vertical;
            white-space: normal;
            font-size: 12px;
            font-weight: 400;
            color: $black;
        }
    }
}

.resourceCard:hover{
    border: 1px solid $black;
}
</style>